// Fixed brand constants, safe to import anywhere (client included).
// Environment-driven settings live in ./env.ts.
export const site = {
  name: "The Dear Jane",
  tagline: "Every gift tells a story for your dear someone",
  motto: "Your thoughtful gift starts here.",
  description:
    "Gift boxes of things they'll actually use, packed by hand and sent with your note written on a card.",
  locale: "en-US",
} as const;

// Products with this tag (box packaging, greeting cards) only make sense inside
// the builder, so they're left out of "Shop all" and search.
export const BUILDER_ONLY_TAG = "builder-only";

// Tags that pick products for the home page (Shopify ignores case). Only
// products tagged "carousel" appear in the photos beside the headline;
// products tagged "featured" fill "Jane's Favorites", which falls back
// to the best sellers when nothing is tagged.
export const HERO_TAG = "carousel";
// Products tagged "box" are gift boxes sold as one product: they fill
// "Boxes we've put together" and the Gift boxes page. Collections listed in
// a "boxes" menu still work too and take precedence when there are any.
export const BOX_TAG = "box";
export const FEATURED_TAG = "featured";

export const PRODUCTS_PER_PAGE = 24;
